import React from 'react';
import { theme } from '../styles';
import { personalInfo } from '../data';

const Footer = ({ isMobile }) => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer style={{
      ...styles.footer,
      padding: isMobile ? '1.5rem 1rem' : '2rem',
    }}>
      <p style={styles.footerText}>
        © {currentYear} {personalInfo.name} - Développeur Web
      </p>
      <div style={{
        ...styles.socialLinks,
        gap: isMobile ? '1rem' : '2rem',
        flexWrap: 'wrap',
      }}>
        <a 
          href={personalInfo.social.github} 
          target="_blank" 
          rel="noopener noreferrer" 
          style={styles.socialLink}
        >
          GitHub
        </a>
        <a 
          href={personalInfo.social.linkedin} 
          target="_blank" 
          rel="noopener noreferrer" 
          style={styles.socialLink}
        >
          LinkedIn
        </a>
        <a 
          href={personalInfo.social.portfolio} 
          target="_blank" 
          rel="noopener noreferrer" 
          style={styles.socialLink}
        >
          Portfolio
        </a>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    borderTop: '1px solid rgba(0, 217, 255, 0.1)',
    textAlign: 'center',
    background: 'rgba(10, 15, 28, 0.9)',
  },
  footerText: {
    color: theme.colors.textDark,
    marginBottom: '1rem',
    fontSize: '0.9rem',
  },
  socialLinks: {
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
  },
  socialLink: {
    color: theme.colors.textMuted,
    textDecoration: 'none',
    fontSize: '0.9rem',
    transition: theme.transition.normal,
    padding: '0.5rem',
  },
};

export default Footer;
